module.exports = __webpack_public_path__ + "img/pocket-watch.9531d9b0.webp";